import { Download, Briefcase, Coffee } from "lucide-react";
import { CTA } from "@/lib/config";

export default function Nav() {
  const items = [
    { label: "Features", href: "#features" },
    { label: "How it works", href: "#how" },
    { label: "History", href: "#history" },
    { label: "FAQ", href: "#faq" },
  ];
  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 dark:bg-black/60 border-b border-zinc-200 dark:border-zinc-800"
    >
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group shrink-0"
        >
          <div className="w-8 h-8 bg-yellow-500 text-black flex items-center justify-center">
            <Download className="w-4 h-4" strokeWidth={3} />
          </div>
          <span className="font-display font-bold text-lg tracking-tight text-zinc-900 dark:text-white group-hover:text-yellow-500 transition-colors whitespace-nowrap">
            GOD <span className="text-yellow-500">of</span> ROAS
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {items.map((i) => (
            <a
              key={i.label}
              href={i.href}
              data-testid={`nav-link-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 hover:text-yellow-500 transition-colors"
            >
              {i.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={CTA.buyCoffee}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-buy-coffee-btn"
            className="hidden sm:inline-flex items-center gap-2 border border-zinc-300 dark:border-zinc-700 hover:border-yellow-500 text-zinc-900 dark:text-white hover:text-yellow-500 font-semibold text-sm px-3 md:px-4 h-10 transition-all hover:-translate-y-0.5"
          >
            <Coffee className="w-4 h-4" strokeWidth={2.5} />
            <span className="hidden md:inline">Buy us a coffee</span>
            <span className="md:hidden">Coffee</span>
          </a>
          <a
            href={CTA.hireUs}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-hire-us-btn"
            className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-sm px-3 md:px-4 h-10 transition-all hover:-translate-y-0.5"
            title="Got impressed? Hire us to run your ads"
          >
            <Briefcase className="w-4 h-4" strokeWidth={2.5} />
            <span className="hidden md:inline">Hire us for ads</span>
            <span className="md:hidden">Hire us</span>
          </a>
        </div>
      </div>
    </header>
  );
}
